import {Fragment, h} from "preact";
import {cartWarningIcon} from "../../../../../assets";
import s from "./cartWarning.module.css";
import {Link} from "preact-router/match";
import {useAppContext} from "../../../../../contexts";

const CartWarning = (props) => {
    // Destructured props
    const {handleCart} = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <Fragment>
            <div className={"w-full flex flex-row gap-x-3 items-start justify-between"}>
                <div className={"shrink-0"}>
                    <img
                        src={cartWarningIcon}
                        alt="Warning icon"
                        className={`${s.warningIcon} ${highContrast ? "filter grayscale" : ""}`}
                    />
                </div>
                <p className={`${s.cartWarning} ${highContrast ? "highLabelFourth" : ""} mb-[1rem]`}>
                    {/*<span className={`text-sabin-red-default font-bold ${highContrast ? "highTitleThird" : ""}`}>*/}
                    {/*    Atenção:&nbsp;*/}
                    {/*</span>*/}
                    Esse processo de compra é exclusivo para pessoas físicas. Cotações e compras para Pessoa Jurídica
                    favor
                    solicitar informações através do nosso Atendimento a Empresas&nbsp;
                    <Link
                        href={"/fale-conosco?option=empresas"}
                        className={`${s.warningLink} ${highContrast ? "highTitleThird" : ""}`}
                        onClick={() => handleCart("isOpen", false)}
                    >
                        clicando aqui.
                    </Link>
                </p>
            </div>
        </Fragment>
    )
}

export default CartWarning;
